import ApiService from '../../../services/api.service'
import moment from 'moment'

export default {

    async _download (path, params) {
        return ApiService.get(path, params, {responseType: 'blob'})
    },

    _buildDateIsBetweenFilter (startDate, endDate, filterKey = 'created_at_is_between') {

        const formatedStartDate = moment(startDate).format('YYYY-MM-DD')
        const formatedEndDate = moment(endDate).format('YYYY-MM-DD')

        return {[`${filterKey}`]: formatedStartDate + ',' + formatedEndDate}
    },

    async downloadCsvOrders (startDate, endDate) {

        const params = {
            filter: {
                ...this._buildDateIsBetweenFilter(startDate, endDate),
            }
        }

        return this._download('/v2/csv-orders', params)
    },

    async downloadCsvBalanceUsers (startDate, endDate) {

        const params = {
            filter: {
                ...this._buildDateIsBetweenFilter(startDate, endDate, 'credits_logs_created_at_is_between'),
            }
        }

        return this._download('/v2/csv-balance-users', params)
    },

    async downloadCsvGainUsers (startDate, endDate) {

        const params = {
            filter: {
                ...this._buildDateIsBetweenFilter(startDate, endDate, 'commissions_partenaires_logs_created_at_is_between'),
            }
        }

        return this._download('/v2/csv-gain-users', params)
    },

    async downloadCsvCreditsLogs (startDate, endDate) {

        const params = {
            filter: {
                ...this._buildDateIsBetweenFilter(startDate, endDate),
            }
        }

        return this._download('/v2/csv-credits-logs', params)
    },

    async downloadCsvSites () {

        return this._download('/v2/csv-sites')
    },
}